import { Navigate } from 'react-router-dom';
import { landingFor } from '@/modules/registry';
import { usePermissions } from '@/hooks/usePermissions';

/** What `/` resolves to: the one module this viewer has, or the apps grid. */
export function LandingRedirect() {
  const { permissions, isPlatform } = usePermissions();
  return <Navigate to={landingFor({ isPlatform, permissions })} replace />;
}
